var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-link"},[_c('a',{staticClass:"active",attrs:{"href":"mailto:support@credittrust.ch","target":"_blank"}},[_c('MDIcon',{staticClass:"icon",attrs:{"icon":"chat"}}),_c('span',[_vm._v(_vm._s(_vm.$t('header:help')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }